<script lang="ts" setup>
defineOptions({
  inheritAttrs: false,
});

defineProps<{
  imageUrl?: string | null | undefined;
  imageAlt?: string | null | undefined;
}>();
</script>

<template>
  <div>
    <NuxtImg
      v-if="imageUrl"
      provider="bunny"
      placeholder="/img/placeholder.svg"
      :src="imageUrl"
      :alt="imageAlt ?? ''"
      :title="imageAlt ?? ''"
      :class="$attrs.class"
      loading="lazy"
    />

    <NuxtImg
      v-if="!imageUrl"
      src="/img/placeholder.svg"
      :alt="imageAlt ?? ''"
      :class="$attrs.class"
    />
  </div>
</template>

<style scoped>

</style>
